import React from 'react'
import { BrowserRouter, Route, Routes, Navigate, HashRouter } from 'react-router-dom'
import ROUTES from './Routes'
import JourneyList from '../pages/JourneyList'
import Workflow from '../pages/Workflow'
import TemplateCreation from '../pages/TemplateCreation'
import CreateAutomationPage from '../pages/CreateAutomationPage'
import EditAutomationPage from '../pages/EditAutomationPage'
import InforUTokenCreationPage from '../pages/InforUTokenCreationPage'

export default function () {
    return (
        <HashRouter>
            <Routes>
                <Route path="/" element={<Navigate to="/journeys" replace />} />
                <Route path={ROUTES.ROOT} element={<JourneyList />} />
                <Route path={ROUTES.WORKFLOW} element={<Workflow />} />
                <Route path={ROUTES.TEMPLATES} element={<TemplateCreation />} />
                <Route path={ROUTES.CREATEAUTOMATION} element={<CreateAutomationPage />} />
                <Route path={ROUTES.EDITAUTOMATION} element={<EditAutomationPage />} />
                <Route path="/*" element={<Navigate to="/journeys" replace />} />
                <Route path={ROUTES.CREATETOKEN} element={<InforUTokenCreationPage />} />
            </Routes>
        </HashRouter>
    )
}
